import React from 'react';
import { stats } from '../data/hero';
export function StatsBar() {
  return <section className="w-full bg-surface px-4 py-10 sm:py-12" data-id="element-217" data-mp="1tai1x90mmpqa">
      <div className="mx-auto grid max-w-6xl grid-cols-2 gap-y-8 text-center sm:grid-cols-3 lg:grid-cols-5" data-id="element-218" data-mp="1tb9nrs4f993d">
        {stats.map(([value, label]) => <div key={label} data-id="element-219" data-mp="1jcu05z4lshym">
            <div className="font-serif text-4xl text-amber" data-id="element-220" data-mp="1jbiws0f2lc81">{value}</div>
            <div className="mx-auto mt-1 max-w-[11rem] text-[10px] font-bold uppercase tracking-[0.13em] text-navy/70 sm:text-xs" data-id="element-221" data-mp="1edhal6mckwsc">
              {label}
            </div>
          </div>)}
      </div>
    </section>;
}